/*
 *@param: 
 *@return: 
 *@Description: 展示最新的课程页面(扩容)
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2019-12-13 16:25:10
*/
export function newCourse(cid){
	return cid>=27 && cid!=29 && cid!=30
}